import { render, staticRenderFns } from "./RecipeInvoiceManagement.vue?vue&type=template&id=a2f1f3ac&scoped=true"
import script from "./RecipeInvoiceManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeInvoiceManagement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecipeInvoiceManagement.vue?vue&type=style&index=0&id=a2f1f3ac&prod&scoped=true&lang=css"
import style1 from "./RecipeInvoiceManagement.vue?vue&type=style&index=1&id=a2f1f3ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f1f3ac",
  null
  
)

export default component.exports